import { IProject } from '@app/api/interfaces/project.interface';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';

export const projectsKey = 'projects';

export const projectsAdapter = createEntityAdapter<IProject>();

export interface IProjectsState extends EntityState<IProject> {
  loading: boolean;
  loaded: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialState: IProjectsState = projectsAdapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});
